// The order of these values represents the order of the layers in the UI
// and is used for z-index.

export enum DisplayOrder {
  Overlay,
  Header,
  SlowActionLoader,
  Controls,
  DarkMode,
}
